// extracted by mini-css-extract-plugin
export default {"arrow":"styles_arrow__tDPZa"};